import { Component } from "../Component";
import { Slider } from "./Slider";
export class ListSlider extends Component {
    init(options = null) {
        const optionsDefault = {
            slidesPerView: {
                webExtraBig: 5,
                webBig: 4,
                web3: 3,
                web2: 2,
                mob: 1,
            },
            scrollModeOnMobile: true,
            spaceBetween: 10
        };
        const newOptions = Object.assign(optionsDefault, options || {});
        this._slider = new Slider(this.html);
        this._slider.init(newOptions);
    }
    setMediaList(list) {
        this._slider.setMediaList(list);
    }
}
